<ng-template #confirm_delete_template
             let-dynamicDialogRef="dynamicDialogRef"
             let-dynamicDialogConfig="dynamicDialogConfig">
  <div class="flex flex-column gap-2">
    {{ dynamicDialogConfig.data.label | translate }}
    <p-footer>
      <div class="flex flex-row justify-content-end align-items-center column-gap-2">
        <button medsurf-design-input-button [id]="'cancel'"
                                     [label]="'global.cancel' | translate"
                                     [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                                     (click)="dynamicDialogRef.close(false)"></button>
        <button medsurf-design-input-button [id]="'action'"
                                     [label]="dynamicDialogConfig.data.inputLabel | translate"
                                     [inputClass]="dynamicDialogConfig.data.inputClass"
                                     (click)="dynamicDialogRef.close(true)"></button>
      </div>
    </p-footer>
  </div>
</ng-template>

<ng-container [ngTemplateOutlet]="dynamicDialogConfig.data.template ?? confirmDelete"
              [ngTemplateOutletContext]="context"></ng-container>